module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-tag mr-5"
  }), _vm._v(" Producten\n    "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCreateProductModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Product\n      ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('small', {
    staticClass: "mr-1"
  }, [_vm._v("Genereer:")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-secondary",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.showStickerGenerator
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o text-danger mr-1"
  }), _vm._v(" Locatie labels")])])]), _vm._v(" "), _c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "created_at",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "image",
      fn: function(data) {
        return [_c('img', {
          key: data.item.id,
          staticClass: "img-avatar img-avatar48",
          attrs: {
            "src": data.item.image_urls[0],
            "alt": ""
          }
        })]
      }
    }, {
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "price",
      fn: function(data) {
        return [(data.item.sale_price) ? _c('sale-price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "sale_price": data.item.sale_price,
            "product-id": data.item.id
          }
        }) : _c('price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "location",
      fn: function(data) {
        return [_c('div', [_c('location-editable', {
          key: data.item.id,
          attrs: {
            "field": "location",
            "value": data.item.location,
            "product-id": data.item.id
          }
        })], 1), _vm._v(" "), _c('div', [_c('small', [_vm._v("\n          Rest:\n          "), _c('field-editable', {
          key: data.item.id,
          attrs: {
            "field": "overstock_location",
            "value": data.item.overstock_location,
            "product-id": data.item.id
          }
        })], 1)])]
      }
    }, {
      key: "in_store",
      fn: function(data) {
        return [_c('in-store-editable', {
          key: data.item.id,
          attrs: {
            "in-store": !!data.value,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "stock_quantity",
      fn: function(data) {
        return [_c('stock-editable', {
          key: data.item.id,
          attrs: {
            "quantity": data.value,
            "product-id": data.item.id
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('select-barcode-scanner-widget'), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      },
      "remove": _vm.refresh
    }
  }) : _vm._e(), _vm._v(" "), (_vm.unkownProductScanned) ? _c('unkown-product-modal', {
    attrs: {
      "barcode": _vm.scannedBarcode
    },
    on: {
      "close": function($event) {
        _vm.unkownProductScanned = null, _vm.scannedBarcode = null
      },
      "unkownProductCreated": _vm.handleUnkownProductCreated
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showStickerGeneratorModal) ? _c('location-sticker-generator', {
    on: {
      "close": function($event) {
        _vm.showStickerGeneratorModal = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locationScanned) ? _c('update-location-modal', {
    attrs: {
      "location": _vm.scannedLocation,
      "productId": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.scannedLocation = null, _vm.locationScanned = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.productsOnScannedLocation) ? _c('location-scanned-modal', {
    attrs: {
      "products": _vm.productsOnScannedLocation
    },
    on: {
      "select": _vm.details,
      "close": function($event) {
        _vm.productsOnScannedLocation = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCreateProductModal) ? _c('create-product-modal', {
    on: {
      "close": function($event) {
        _vm.showCreateProductModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-680ff4c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/ProductsPage.vue
// module id = 730
// module chunks = 1